// @docs https://[domain]/api/v1/docs
export default {
  SignIn: "/auth/signin",
  GetMe: "/auth/me",
  RefreshToken: "/auth/refresh-token",
  Permissions: "/auth/perms",
};
